import Vue from 'vue';
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import store from './store';
import App from './App.vue';


Vue.config.productionTip = false;
const vuetify = new Vuetify({
  icons: {
    iconfont: "md"
  },
  theme: {
    dark: false,
    light: {
      primary: '#327bba',
    }
  }
});

Vue.use(Vuetify)

var vm = new Vue({
  vuetify,
  store,
  render: (h) => h(App),
}).$mount('#sirv-price-widget');
